export enum CATALOG {
    /**
     * @value This page gives you access to all catalog categories, training courses or learning paths created.
     */
    ACCESS_TO_CATALOG = 'LEARNING.THIS_PAGE_WILL_GIVE_ACCESS_TO_CATALOG',
    /**
     * @value Category changed to: %CATEGORY_NAME%
     */
    CATEGORY_CHANGED_TO = 'CATALOG.CATEGORY_CHANGED_TO',
    /**
     * @value Learning catalog loaded
     */
    LEARNING_CATALOG_LOADED = 'CATALOG.LEARNING_CATALOG_LOADED',
    /**
     * @value No catalog results yet
     */
    NO_CATALOG = 'LEARNING.NO_CATALOG_COURSES',
    /**
     * @value Search catalog
     * @description Placeholder display on the search field
     */
    SEARCH = 'LEARNING.SEARCH_CATALOG',
    /**
     * @value Display elements (and all sub-elements) from a specific learning category.
     */
    SELECT_CATEGORY_HELPER = 'LEARNING.WIDGET_TYPE_CATALOG_SELECT_CATEGORY_HELP',
}
